import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'
import WebSocket from './modules/websocket'
import User from './modules/user'
import Activity from './modules/activity'
import Field from './modules/field'
import Product from './modules/product'
import Channel from './modules/channel'
import Order from './modules/order'

let debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

let plugins = []

plugins.push(createPersistedState())

if (debug) {
  plugins.push(createLogger())
}

let modulesList = {WebSocket, User, Activity, Field, Channel, Order, Product}

const store = new Vuex.Store({
  modules: modulesList,
  plugins: plugins,
  strict: debug
})
//
if (module.hot) {
  module.hot.accept(modulesList, () => {
    const newMutations = modulesList.default

    store.hotUpdate({
      mutations: newMutations
    })
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js